module.exports = __webpack_public_path__ + "img/login-building.32bf93ca.png";